import React from 'react';
import { statsData } from '../../data/mock';
import { useScrollAnimation, AnimatedCounter } from '../../hooks/useScrollAnimation';

const StatsSection = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.3 });

  // Parse stat value to extract number and suffix
  const parseStatValue = (value) => {
    const match = value.match(/^(\d+\.?\d*)(.*)$/);
    if (match) {
      return { number: parseFloat(match[1]), suffix: match[2] };
    }
    return { number: 0, suffix: value };
  };

  return (
    <section ref={ref} className="bg-black py-12 md:py-16 lg:py-20 border-y border-white/[0.06]">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-12">
          {statsData.map((stat, index) => {
            const { number, suffix } = parseStatValue(stat.value);
            return (
              <div 
                key={stat.id}
                className="text-center md:text-left group"
                style={{
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                  transition: `all 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${index * 150}ms`
                }}
              >
                <span className="text-2xl md:text-3xl lg:text-5xl font-extralight text-white/90 tracking-tight inline-block transition-all duration-300 group-hover:text-amber-400">
                  {isVisible ? (
                    <AnimatedCounter 
                      end={number} 
                      duration={2000} 
                      suffix={suffix}
                      decimals={suffix.includes('%') ? 0 : 0}
                    />
                  ) : stat.value}
                </span>
                <p className="text-white/35 text-[10px] md:text-xs lg:text-sm mt-1 md:mt-2 font-light tracking-wide transition-all duration-300 group-hover:text-white/50">
                  {stat.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
